import { createTheme, PaletteMode } from '@mui/material';
import type {} from '@mui/x-date-pickers-pro/themeAugmentation';
import { getComponents } from './component-overrides';
import { addGlobalStyles } from './global-styles';
import { getMixins } from './mixins';
import { getPaletteOptions } from './palette';
import { getTypography } from './typography';
import { unityRadiusTokens } from './unityTokens';

export interface GetThemeOptions {
  enableNewLogoStubYear?: boolean;
  panwRebrandStubYear?: boolean;
}

/**
 * Gets theme used by all components for the provided mode. For more details, see:
 *   - Base colors, typography, sizing - go/chrono-ui-theme
 *   - Material UI defaults: https://material-ui.com/customization/default-theme/
 *   - Material UI variables: https://material-ui.com/customization/theming/#theme-configuration-variables
 *   - Material UI global overrides and default props: https://material-ui.com/customization/globals/#css
 *
 * Need to reinstantiate the theme everytime to support switching between light and dark themes
 * https://github.com/mui-org/material-ui/issues/18831
 */
export function getTheme(mode: PaletteMode, opts: GetThemeOptions, applicationRoot?: string) {
  const theme = createTheme({
    palette: getPaletteOptions(mode, opts),
    typography: getTypography(opts),
    mixins: getMixins(mode),
    shape: {
      borderRadiusXs: unityRadiusTokens['--border-radius-xs'],
      borderRadiusSm: unityRadiusTokens['--border-radius-sm'],
      borderRadiusMd: unityRadiusTokens['--border-radius-md'],
      borderRadiusLg: unityRadiusTokens['--border-radius-lg'],
      borderRadiusXl: unityRadiusTokens['--border-radius-xl'],
    },
    featureFlags: {
      panwRebrandStubYear: opts.panwRebrandStubYear ?? false,
    },
    components: getComponents(opts),
  });
  addGlobalStyles(theme, applicationRoot);
  return theme;
}
